import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

const customTypography = [
  "title-72",
  "title-64",
  "title-60",
  "title-56",
  "title-48",
  "title-40",
  "title-36",
  "title-32",
  "title-24",
  "title-20",
  "title-18",
  "title-16",
  "title-14",
  "title-12",
  "title-highlight-36",
  "title-highlight-56",
  "body-20",
  "body-18",
  "body-17",
  "body-16",
  "body-14",
  "body-12",
  "captitle-16",
  "captitle-14",
  "captitle-12",
  "captitle-10",
] as const;

const twMerge = extendTailwindMerge<"custom-typography">({
  extend: {
    classGroups: {
      "custom-typography": customTypography.map((c) => c),
    },
    conflictingClassGroups: {
      "custom-typography": [
        "font-size",
        "leading",
        "font-weight",
        "tracking",
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
